export const privacyNoticeText = {
  en: {
    title: 'Your privacy matters to us',
    description: 'We use self-hosted, cookieless analytics to understand overall visits, without linking analytics to your account. We do not use Google Analytics or advertising trackers. Sign-in and app features use essential browser storage. {privacyPolicy}',
    okay: 'Okay', close: 'Close', policy: 'Privacy policy',
  },
  pl: {
    title: 'Twoja prywatność jest dla nas ważna',
    description: 'Korzystamy z samodzielnie hostowanej analityki bez plików cookie, aby mierzyć ogólną liczbę odwiedzin, bez łączenia statystyk z Twoim kontem. Nie używamy Google Analytics ani narzędzi reklamowych do śledzenia. Logowanie i funkcje aplikacji korzystają z niezbędnej pamięci przeglądarki. {privacyPolicy}',
    okay: 'Rozumiem', close: 'Zamknij', policy: 'Polityka prywatności',
  },
  uk: {
    title: 'Ваша конфіденційність важлива для нас',
    description: 'Ми використовуємо аналітику на власній інфраструктурі без файлів cookie для підрахунку відвідувань, не пов’язуючи статистику з вашим обліковим записом. Ми не використовуємо Google Analytics або рекламні трекери. Вхід і функції застосунку використовують необхідне сховище браузера. {privacyPolicy}',
    okay: 'Зрозуміло', close: 'Закрити', policy: 'Політика конфіденційності',
  },
};

export function privacyNoticeConfig() {
  return {
    elementID: 'wlasnasprawa-privacy-notice',
    storageMethod: 'localStorage',
    storageName: 'wlasnasprawa.privacyNotice.v2',
    lang: 'en',
    fallbackLang: 'en',
    mustConsent: false,
    acceptAll: false,
    default: false,
    hideLearnMore: true,
    hideDeclineAll: false,
    showNoticeTitle: true,
    htmlTexts: false,
    // Informational acknowledgment only. Neither button enables any service.
    services: [],
    translations: Object.fromEntries(Object.entries(privacyNoticeText).map(([lang, text]) => [lang, {
      consentNotice: { title: text.title, description: text.description },
      ok: text.okay,
      decline: text.close,
      privacyPolicy: { name: text.policy },
      privacyPolicyUrl: '/privacy-policy.html',
    }])),
  };
}
